import schema from '@/framework/logic/schema/set-component-children.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';

const mapSetComponentChildren = action => ({
  type: 'LAYOUT_SET_COMPONENT_CHILDREN',
  payload: {
    value: action.data.value,
    path: action.data.path,
  },
});

const setComponentChildren = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapSetComponentChildren(
    validated(interpolate(meta.action, event, context))
  );
};

export default setComponentChildren;
